<template>
    <tr class="licence__show_table_item">
        <td class="licence__show_table_item_accessedby">{{ licenceAccessedBy }}</td>
        <td class="licence__show_table_item_latestaccessdate">
            <template v-if="licenceLatestAccessDate && licenceLatestAccessTime">
                {{ licenceLatestAccessDate }}
                <component-text :size="'small'">Time: {{ licenceLatestAccessTime }}</component-text>
            </template>
            <template v-else>-</template>
        </td>
        <td class="licence__show_table_item_numberofattempts">{{ licenceNumberOfAttempts }}</td>
        <td class="licence__show_table_item_actions">
            <div class="columns is-variable">
                <div class="column"></div>
                <template v-if="licenceNumberOfAttempts">
                <div class="column is-narrow">
                    <component-button
                        :name="'dashboard-list-table-item-collapse'"
                        :icon="true"
                        :icon-name="collapseActive ? 'chevron-up' : 'chevron-down'"
                        :theme="'default'"
                        @click="performEmit('emit-collapse', index)"
                    />
                </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentText from '@/components/default/shared/ComponentText'
import { User } from '@/User'
import { fromUTCDateTimeToLocalISOCustom, toLocaleDateTime, toLocaleTime } from '@/functions'

export default {
  name: 'licence-show-table-item',
  components: { ComponentText, ComponentButton },
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: [Number, String]
    },
    collapseActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    licenceAccessedBy () {
      return this.item.learner ? `${this.item.learner.firstName} ${this.item.learner.lastName}` : '-'
    },
    licenceLatestAccessDate () {
      return this.item.latestAttempt ? toLocaleDateTime(fromUTCDateTimeToLocalISOCustom(this.item.latestAttempt)) : null
    },
    licenceLatestAccessTime () {
      return this.item.latestAttempt ? toLocaleTime(fromUTCDateTimeToLocalISOCustom(this.item.latestAttempt)) : null
    },
    licenceNumberOfAttempts () {
      return this.item.totalAttempts
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>
